import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EditButtonComponent } from './edit-button.component';
import { FeahterIconModule } from 'src/app/core/feather-icon/feather-icon.module';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';



@NgModule({
  declarations: [
    EditButtonComponent
  ],
  imports: [
    CommonModule,
    FeahterIconModule,
    NgbTooltipModule
  ],
  exports: [
    EditButtonComponent
  ]
})
export class EditButtonModule { }
